import QuestionnaireShell from "./QuestionnaireShell";

const sections = [
    {
        title: "Personal & Family Profile",
        questions: [
            { id: "age", label: "Age", type: "number" },
            { id: "marital_status", label: "Marital status", notes: "Single / Married / Divorced" },
            { id: "dependents", label: "Number of dependents", type: "number" },
            { id: "city", label: "City / State" },
            { id: "education", label: "Highest education" },
            { id: "employer", label: "Current employer / business name" },
            { id: "years_in_role", label: "Years in current role", type: "number" },
            { id: "stability", label: "Job stability rating (1–10)", type: "number" },
        ],
    },
    {
        title: "Income — Detailed Breakdown",
        questions: [
            { id: "primary_income", label: "Primary salary / business income (₹/month)", type: "number", notes: "Net take-home" },
            { id: "spouse_income", label: "Spouse / partner income (₹/month)" },
            { id: "freelance_income", label: "Freelance / side income (₹/month)" },
            { id: "rental_income", label: "Rental income (₹/month)" },
            { id: "dividend_income", label: "Interest / dividend income (₹/month)" },
            { id: "other_income", label: "Any other income (₹/month)", notes: "Specify source" },
            { id: "bonus", label: "Annual bonus (₹)" },
            { id: "income_growth", label: "Expected income growth next 2 years (%)" },
        ],
    },
    {
        title: "Debt Inventory",
        description: "List each debt briefly. You can add up to 5 in the notes if needed.",
        questions: [
            { id: "debt1", label: "Debt 1 — Type, Lender, Outstanding, Rate, EMI, Tenure", type: "textarea" },
            { id: "debt2", label: "Debt 2 — Type, Lender, Outstanding, Rate, EMI, Tenure", type: "textarea" },
            { id: "debt3", label: "Debt 3 — Type, Lender, Outstanding, Rate, EMI, Tenure", type: "textarea" },
            { id: "debt4", label: "Debt 4 (if any)", type: "textarea" },
            { id: "debt5", label: "Debt 5 (if any)", type: "textarea" },
            { id: "total_cards", label: "Total credit cards", type: "number" },
            { id: "cards_detail", label: "Cards — Bank, Limit, Outstanding, Rate", type: "textarea" },
            { id: "restructured_before", label: "Any EMI moratorium / restructuring done before?" },
            { id: "cibil", label: "CIBIL score (if known)" },
        ],
    },
    {
        title: "Monthly Expense Deep-Dive",
        questions: [
            { id: "rent_emi", label: "Rent / Home loan EMI (₹)", type: "number" },
            { id: "maintenance", label: "Maintenance / Society charges (₹)" },
            { id: "utilities", label: "Electricity / Water / Gas (₹)" },
            { id: "groceries", label: "Groceries & Daily needs (₹)" },
            { id: "domestic_help", label: "Domestic help / cook / driver (₹)" },
            { id: "school_fees", label: "School / Tuition fees (₹)" },
            { id: "transport", label: "Transport — Fuel / Metro / Cab (₹)" },
            { id: "mobile_net", label: "Mobile / Internet / DTH (₹)" },
            { id: "insurance_life", label: "Life insurance premium (₹/month)" },
            { id: "insurance_health", label: "Health insurance premium (₹/month)" },
            { id: "insurance_vehicle", label: "Vehicle insurance premium (₹/month)" },
            { id: "ott", label: "OTT subscriptions total (₹)" },
            { id: "gym", label: "Gym / Club memberships (₹)" },
            { id: "dining", label: "Dining out & food delivery (₹)" },
            { id: "shopping", label: "Shopping — clothes, gadgets (₹)" },
            { id: "medical", label: "Avg. monthly medical (₹)" },
            { id: "donations", label: "Donations / religious (₹)" },
            { id: "other_expense", label: "Other regular expense (₹)" },
        ],
    },
    {
        title: "Assets & Savings",
        questions: [
            { id: "emergency", label: "Emergency fund (₹)", type: "number" },
            { id: "fd", label: "Fixed Deposits (₹)" },
            { id: "mf", label: "Mutual Funds (₹)" },
            { id: "stocks", label: "Stocks / Equity (₹)" },
            { id: "ppf", label: "PPF / EPF balance (₹)" },
            { id: "gold", label: "Gold / Jewellery (₹)" },
            { id: "realestate", label: "Real estate other than primary home" },
            { id: "other_invest", label: "Other investments (crypto, NPS, etc.)" },
            { id: "sip", label: "Monthly SIP amount (₹)" },
        ],
    },
    {
        title: "Behavioural & Strategic",
        questions: [
            { id: "debt_trigger", label: "What triggered your current debt situation?", type: "textarea" },
            { id: "tried_before", label: "Have you tried debt management before? What worked / didn't?", type: "textarea" },
            { id: "negotiation", label: "Comfortable negotiating with banks? (Yes / No / Need help)" },
            { id: "income_boost", label: "Can you increase income in next 3 months? How?", type: "textarea" },
            { id: "non_negotiable", label: "Expenses you absolutely cannot cut", type: "textarea" },
            { id: "willing_to_cut", label: "Expenses willing to reduce or eliminate", type: "textarea" },
            { id: "target_months", label: "Target: debt-free in how many months?", type: "number" },
            { id: "freedom_means", label: "What does 'financial freedom' mean to you?", type: "textarea" },
            { id: "anything_else", label: "Anything else we should know?", type: "textarea" },
        ],
    },
];

export default function NitiForm() {
    return (
        <QuestionnaireShell
            title="Niti Questionnaire"
            tagline="Niti · Strategic Assessment · ₹1,969"
            packageKey="niti"
            sections={sections}
        />
    );
}
